import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsVideoThumbnailNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M6 3.057C6 1.39 7.923.454 9.236 1.485l11.381 8.942a2 2 0 010 3.146L9.236 22.515C7.923 23.546 6 22.611 6 20.943zM19.381 12L8 3.057v17.886z"
        fill=""
      />
    </svg>
  )
);
SvgActionsVideoThumbnailNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsVideoThumbnailNormalSmall;
